import { useState } from "react";
import { FileDown, Loader2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function FlyerDownloadButton({ product, accent = "#1b75bc", accentHover = "#155e97" }) {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/product-flyer/${product}`);
      if (!res.ok) throw new Error(`Request failed (${res.status})`);
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${product}-flyer.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error("Flyer download failed", e);
      alert("Sorry, the flyer could not be generated. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      data-testid={`download-flyer-${product}`}
      onClick={handleDownload}
      disabled={loading}
      className="inline-flex items-center gap-2 font-heading uppercase tracking-[0.2em] text-sm text-white px-10 py-4 transition-colors duration-300 disabled:opacity-70"
      style={{ backgroundColor: accent }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = accentHover)}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = accent)}
    >
      {loading ? (
        <>
          <Loader2 size={16} className="animate-spin" /> Generating…
        </>
      ) : (
        <>
          <FileDown size={16} /> Download Product Flyer
        </>
      )}
    </button>
  );
}
